import { withoutSpace } from '../helpers.mjs';

const conditionsStr = "_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_invalid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_default,_optional,_open,_closed,_fullscreen,_loading,_currentPage,_currentStep,_motionReduce,_motionSafe,_print,_landscape,_portrait,_dark,_light,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_starting,_collapsed,_current,_hidden,_off,_on,_today,_underValue,mobile,mobileOnly,mobileDown,sm,smOnly,smDown,md,mdOnly,mdDown,tablet,tabletOnly,tabletDown,desktop,desktopOnly,desktopDown,lg,lgOnly,lgDown,xl,xlOnly,xlDown,desktopLg,desktopLgOnly,desktopLgDown,2xl,2xlOnly,2xlDown,mobileToSm,mobileToMd,mobileToTablet,mobileToDesktop,mobileToLg,mobileToXl,mobileToDesktopLg,mobileTo2xl,smToMd,smToTablet,smToDesktop,smToLg,smToXl,smToDesktopLg,smTo2xl,mdToTablet,mdToDesktop,mdToLg,mdToXl,mdToDesktopLg,mdTo2xl,tabletToDesktop,tabletToLg,tabletToXl,tabletToDesktopLg,tabletTo2xl,desktopToLg,desktopToXl,desktopToDesktopLg,desktopTo2xl,lgToXl,lgToDesktopLg,lgTo2xl,xlToDesktopLg,xlTo2xl,desktopLgTo2xl,@/mobile,@/tablet,@/desktop,@trade-page-body/mobile,@trade-page-body/tablet,@trade-page-body/desktop,base"
const conditions = new Set(conditionsStr.split(','))

export function isCondition(value){
  return conditions.has(value) || /^@|&|&$/.test(value)
}

const underscoreRegex = /^_/
const conditionsSelectorRegex = /&|@/

export function finalizeConditions(paths){
  return paths.map((path) => {
    if (conditions.has(path)){
      return path.replace(underscoreRegex, '')
    }

    if (conditionsSelectorRegex.test(path)){
      return `[${withoutSpace(path.trim())}]`
    }

    return path
  })}

  export function sortConditions(paths){
    return paths.sort((a, b) => {
      const aa = isCondition(a)
      const bb = isCondition(b)
      if (aa && !bb) return 1
      if (!aa && bb) return -1
      return 0
    })
  }